export const MONTHS = 'Januar Februar März April Mai Juni Juli August September Oktober November Dezember';
